import React from "react";

function hashToColor(s: string): string {
  let h = 0;
  for (const ch of s) h = ((h << 5) - h + ch.charCodeAt(0)) | 0;
  const hue = Math.abs(h) % 360;
  return `hsl(${hue}, 60%, 50%)`;
}

export const WorkspaceBadge: React.FC<{ slug: string; label?: string }> = ({
  slug,
  label,
}) => {
  // Personal workspaces have slug like "personal:<email>" — show "Personal" not the email.
  const displayed =
    label ?? (slug.startsWith("personal:") ? "Personal" : slug);
  return (
    <span
      className="plbx-ws-badge"
      title={slug}
      style={{ background: hashToColor(slug) }}
    >
      {displayed}
    </span>
  );
};

export default WorkspaceBadge;
